import ApiManager from '../managers/ApiManager';
import {prepareCart} from '@functions/helpers/cartHelper';
import isEqual from '@assets/helpers/utils/isEqual';
import {getStorageData, setStorageData} from '@scripttag/helpers/storageHelpers';
import {getCartTokenStore, setCartToken} from '@scripttag/helpers/cartTokenStore';

const SHOPIFY_BASE_URL = window.Shopify?.routes?.root || '/';
const CART_STORAGE_KEY = 'avada-chatty/cart';

/**
 * @param {function} callback
 * @param {function} verifyUrl
 * @returns {void}
 */
function mixinFetch(callback, verifyUrl) {
  const originalFetch = window.fetch;
  window.fetch = function() {
    const promise = originalFetch.apply(this, arguments);
    return promise.then(response => {
      try {
        if (verifyUrl(arguments)) callback(arguments, response);
      } catch (e) {
        console.error(e);
      }
      return promise;
    });
  };
}
const isCartAdd = u => String(typeof u === 'string' ? u : u?.url ?? '').includes('/cart/add');
const isCartChange = u => String(typeof u === 'string' ? u : u?.url ?? '').includes('/cart/change');
const isCartMutate = u => isCartAdd(u) || isCartChange(u);

async function safeJson(resp) {
  try {
    return await resp.clone().json();
  } catch {
    return null;
  }
}

/**
 * @returns {void}
 */
export const bindCartEvent = () => {
  const mixinUrls = ['/cart/add', '/cart/change'];
  const isDisableCartTracking = window.AVADA_APP_FAQS_STATUS?.disableCartTracking;
  if (isDisableCartTracking) return console.log(`[Chatty] Cart tracking is disabled`);

  const callback = async (args, response) => {
    try {
      // eslint-disable-next-line no-unused-vars
      const [url, _init] = args;
      if (!isCartMutate(url)) return;

      // Handle cart add events
      if (isCartAdd(url)) {
        const cartId = getCartTokenStore().get();
        const isValidCartId = cartId && cartId.includes('?key=');
        if (!isValidCartId) {
          const cart = await getCart();
          setCartToken(cart.token);
        }
      }

      if (isCartChange(url)) {
        const cart = await safeJson(response);
        setCartToken(cart.token);
      }
    } catch (error) {
      console.error('[Chatty] - Error in cart event callback:', error);
    }
  };

  const verifyUrl = ([url]) => mixinUrls.some(x => url.includes?.(x) || url.url?.includes(x));
  mixinFetch(callback, verifyUrl);
};

export const checkAndSaveCart = async (sessionId, toInitCart = false) => {
  const storedCart = getStorageData(CART_STORAGE_KEY, null);
  if (!storedCart && !toInitCart) return; // skip check and save cart if not existed yet
  if (!sessionId) return;

  const rawCart = await getCart();
  const cart = prepareCart(rawCart);
  if (isEqual(cart, storedCart)) return;

  const apiClient = new ApiManager();

  const {shopId} = window.AVADA_APP_FAQS_STATUS;
  const resp = await apiClient.postData('/activity/carts/save', {cart, shopId, sessionId});
  if (resp.success) setStorageData(CART_STORAGE_KEY, cart);
};

/**
 *
 * @returns {Promise<object>}
 */
async function getCart() {
  const resp = await fetch(SHOPIFY_BASE_URL + 'cart.js', {
    headers: {'Content-Type': 'application/json'}
  });
  return resp.json();
}
